import React from 'react';
import TowerImages from './TowerImages';

// Example of how the complete tower annotation flow works
const TowerAnnotationFlowExample = () => {
  // Example data that would come from your parent component
  const exampleImages = [
    {
      id: "collection-123",
      name: "Tower Collection 1"
    }
  ];

  const exampleUserDetails = {
    project_id: "project-456",
    plan_id: "plan-789",
    blob_container: "your-container",
    username: "user@example.com"
  };

  return (
    <div>
      <h2>Tower Annotation Flow</h2>
      <p>Click on any image to navigate to the annotation interface</p>
      
      <TowerImages 
        images={exampleImages}
        userDetails={exampleUserDetails}
      />
      
      <div style={{ marginTop: "20px", padding: "10px", backgroundColor: "#f5f5f5" }}>
        <h3>Flow Description:</h3>
        <ol>
          <li>User clicks on an image in TowerImages component</li>
          <li>Component creates mock annotation set, task, and classes</li>
          <li>Navigates to PickStorkTowerDetector with all required data</li>
          <li>PickStorkTowerDetector loads ImagesAnnotation component</li>
          <li>User can now annotate the tower image with full functionality</li>
        </ol>
      </div>
    </div>
  );
};

export default TowerAnnotationFlowExample;
